import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Check, X } from "lucide-react";
import apiClient from "@/api/client";
import { aronKeys, invalidateAronConversations, useAronApiBase } from "../api/aronApi";
import type { AronConversation } from "../types";

/**
 * Werdykt właściciela nad CAŁĄ misją rozmowy ("czy się udało"). Sukces karmi pętlę
 * doświadczenia: META-ARON destyluje z wygranej notatkę wiedzy (auto-aktywną — klik
 * JEST akceptacją człowieka). Porażka jest tylko zapisywana — z przegranych ARON
 * nie uczy się tłumaczeń (decyzja właściciela 2026-08-22).
 */
export function AronMissionVerdict({
  conversationId,
  value,
}: {
  conversationId?: string | null;
  value?: boolean | null;
}) {
  const base = useAronApiBase();
  const qc = useQueryClient();
  const set = useMutation({
    mutationFn: async (success: boolean) => {
      const r = await apiClient.post<{ data: AronConversation }>(
        `${base}/conversations/${conversationId}/mission-outcome/`,
        { success },
      );
      return r.data.data;
    },
    onSuccess: () => {
      invalidateAronConversations(qc);
      void qc.invalidateQueries({ queryKey: aronKeys.conversations(base) });
    },
  });
  if (!conversationId) return null;
  const chip =
    "inline-flex h-6 shrink-0 items-center gap-1 border px-1.5 text-[11px] transition-colors disabled:opacity-50";
  return (
    <span className="inline-flex items-center gap-1" title="Werdykt misji: wygrana uczy ARONA (notatka wiedzy), porażka tylko się zapisuje.">
      <button
        type="button"
        disabled={set.isPending}
        onClick={() => set.mutate(true)}
        className={`${chip} ${
          value === true
            ? "border-green-600 bg-green-600 font-medium text-white"
            : "border-gray-200 text-gray-500 hover:border-green-600 hover:text-green-700 dark:border-gray-700 dark:text-gray-400"
        }`}
      >
        <Check size={11} /> Udana
      </button>
      <button
        type="button"
        disabled={set.isPending}
        onClick={() => set.mutate(false)}
        className={`${chip} ${
          value === false
            ? "border-red-600 bg-red-600 font-medium text-white"
            : "border-gray-200 text-gray-500 hover:border-red-500 hover:text-red-600 dark:border-gray-700 dark:text-gray-400"
        }`}
      >
        <X size={11} /> Nieudana
      </button>
    </span>
  );
}
